export const defaultIcon =
  'https://frontdoorcdn.mindverse.ai/mindos-resource/front-img/crm/202405201716177637308defaultIcon.png';
